import { ArticleHeading3 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './styles/groupHeader.css';
import { Header } from '../../../base/Header';

interface IGroupHeaderProps {
  title: string;
  subtitle?: React.ReactNode;
}

export function GroupHeader({ title, subtitle }: IGroupHeaderProps) {
  return (
    <Header basic>
      <div className={styles['content']} data-testid="GroupHeader">
        <ArticleHeading3>{title}</ArticleHeading3>
        {subtitle && <div className={styles['subtitle']}>{subtitle}</div>}
      </div>
    </Header>
  );
}
